export default __webpack_public_path__ + "static/media/ic-back-arrow (1).4a49e945.svg";